import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import BankReceiptIndex from '../../../components/bankReceipts'
import './style.scss'
const BankReceiptPages = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <BankReceiptIndex
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default BankReceiptPages
/* ChequesIndex */